// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_VGDYf","points":"points_dvSdZ","primary":"primary_XCcMd","reverse":"reverse_TOXvJ"};